import React from "react"
import ModalCloseIcon from "@material-ui/icons/Close"
import { makeStyles } from "@material-ui/core/styles"
import IconButton from "@material-ui/core/IconButton"

const useStyle = makeStyles(theme => ({
  modalCloseIcon: {
    width: "40px",
    height: "40px",
    color: "#fff",
    background: "#b1b1b3",
    borderRadius: "20px",
    position: "absolute",
    top: "-15px",
    right: "-13px",
    "&:hover": {
      color: "#d1d1d3",
      background: "#a1a1a3",
    },
  },
}))

const CloseIcon = props => {
  const classes = useStyle()

  return (
    <IconButton
      aria-label="clear"
      size="small"
      {...props}
      className={classes.modalCloseIcon}
    >
      <ModalCloseIcon />
    </IconButton>
  )
}
export default CloseIcon
